<div class="links-wrapper" *ngIf="links$ | async as links; else spinner">
  <div *ngFor="let link of links" class="tile-link-container">
    <a routerLink="/book" [queryParams]="{ path: 'Page=' + link.page }" class="tile-link">
      <div class="tile-link-image">
        <svg class="tile-link-ico">
          <use href="'/assets/images/svg_ico/icons.svg#ic_book_' + link.code"></use>
        </svg>
      </div>
      <div class="tile-link-caption">
        <span>{{ linkTitles[link.code] }}</span>
      </div>
    </a>
  </div>
</div>
<parser-plugin-link></parser-plugin-link>
<ng-template #spinner>
  <spinner></spinner>
</ng-template>
